import _ from 'lodash'
import student from './shared/student'
import { ActionTypes } from '../constants'
import diplomas from './shared/diplomas'
import statistics from './parents/statistics'

const parents = (state = {
  child: student(undefined, {}),
  diplomas: {},
  pretend: {
    fetching: false
  },
  children: {
    objects: {},
    fetching: false,
    didInvalidate: false,
    updatedOn: null,
    error: null
  },
  statistics: statistics(undefined, {})
}, action) => {
  switch (action.type) {
  case ActionTypes.CHILDREN_REQUEST:
    return {
      ...state,
      children: Object.assign({}, state.children, {
        fetching: true,
        error: null,
        didInvalidate: false
      })
    }

  case ActionTypes.CHILDREN_RECEIVING_SUCCESS:
    return {
      ...state,
      children: Object.assign({}, state.children, {
        fetching: false,
        updatedOn: action.updatedOn,
        objects: _.mapValues(_.keyBy(action.children, 'id'), (value) => {
          return student(undefined, {
            type: ActionTypes._STUDENT_ACTION_SUCCESS,
            object: value
          })
        })
      })
    }

  case ActionTypes.CHILDREN_RECEIVING_FAILURE:
    return {
      ...state,
      children: Object.assign({}, state.children, {
        fetching: false,
        error: action.error,
        didInvalidate: true
      })
    }

  case ActionTypes.ADD_CHILD_REQUEST:
    return {
      ...state,
      child: student(state.child || undefined, {
        type: ActionTypes._STUDENT_ACTION_REQUEST,
        object: action.object
      })
    }

  case ActionTypes.ADD_CHILD_SUCCESS:
    return {
      ...state,
      child: student(undefined, {}),
      children: Object.assign({}, state.children, {
        didInvalidate: true,
        objects: Object.assign({}, state.children.objects, {
          [action.object.id]: student(undefined, {
            type: ActionTypes._STUDENT_ACTION_SUCCESS,
            object: action.object
          })
        })
      })
    }

  case ActionTypes.ADD_CHILD_FAILURE:
    return {
      ...state,
      child: student(state.child, {
        type: ActionTypes._STUDENT_ACTION_FAILURE,
        error: action.error
      })
    }

  case ActionTypes.UPDATE_CHILD_REQUEST:
  case ActionTypes.DESTROY_CHILD_REQUEST:
    return {
      ...state,
      children: Object.assign({}, state.children, {
        objects: Object.assign({}, state.children.objects, {
          [action.object.id]: student(undefined, {
            type: ActionTypes._STUDENT_ACTION_REQUEST,
            object: action.object
          })
        })
      })
    }

  case ActionTypes.UPDATE_CHILD_SUCCESS:
    return {
      ...state,
      children: Object.assign({}, state.children, {
        didInvalidate: true,
        objects: Object.assign({}, state.children.objects, {
          [action.object.id]: student(undefined, {
            type: ActionTypes._STUDENT_ACTION_SUCCESS,
            object: action.object
          })
        })
      })
    }

  case ActionTypes.DESTROY_CHILD_FAILURE:
  case ActionTypes.UPDATE_CHILD_FAILURE:
    return {
      ...state,
      children: Object.assign({}, state.children, {
        objects: Object.assign({}, state.children.objects, {
          [action.object.id]: student(state.children.objects[action.object.id], {
            type: ActionTypes._STUDENT_ACTION_FAILURE,
            error: action.error
          })
        })
      })
    }

  case ActionTypes.DESTROY_CHILD_SUCCESS:
    return {
      ...state,
      children: {
        ...state.children,
        objects: _.omit(state.children.objects, action.object.id)
      }
    }

  case ActionTypes.CHILDREN_DIPLOMAS_REQUEST:
  case ActionTypes.CHILDREN_DIPLOMAS_RECEIVING_SUCCESS:
  case ActionTypes.CHILDREN_DIPLOMAS_RECEIVING_FAILURE:
    return {
      ...state,
      diplomas: Object.assign({}, state.diplomas, {
        [action.event]: diplomas(state.diplomas[action.event], action)
      })
    }

  case ActionTypes.PARENT_PRETEND_REQUEST:
  case ActionTypes.PARENT_PRETEND_SUCCESS:
  case ActionTypes.PARENT_PRETEND_FAILURE:
    return {
      ...state,
      pretend: Object.assign({}, state.pretend, {
        fetching: !state.pretend
      })
    }

  case ActionTypes.CHILDREN_STATISTICS_REQUEST:
  case ActionTypes.CHILDREN_STATISTICS_RECEIVING_SUCCESS:
  case ActionTypes.CHILDREN_STATISTICS_RECEIVING_FAILURE:
    return {
      ...state,
      statistics: Object.assign({}, statistics(state.statistics, action))
    }

  default:
    return state
  }
}

export default parents
